/**
 * Zeus Releases Deck — stacked card carousel with shuffle cascade.
 * Scoped per section instance via [data-zeus-releases-deck].
 */
(function () {
  var SHUFFLE_MS = 300;
  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function parseImages(card) {
    try {
      var raw = JSON.parse(card.getAttribute("data-images") || "[]");
      return raw.filter(function (url) {
        return typeof url === "string" && url.trim().length > 0;
      });
    } catch (e) {
      return [];
    }
  }

  function collectImages(card) {
    var parsed = parseImages(card);
    if (parsed.length) return parsed;

    var layers = card.querySelectorAll(".zeus-releases-deck__layer img");
    var imgs = [];
    for (var i = layers.length - 1; i >= 0; i--) {
      if (layers[i].src) imgs.push(layers[i].src);
    }
    return imgs;
  }

  function initCard(card) {
    var imgs = collectImages(card);
    if (!imgs.length) return;

    var stack = card.querySelector(".zeus-releases-deck__stack");
    var layers = card.querySelectorAll(".zeus-releases-deck__layer img");
    var prev = card.querySelector(".zeus-releases-deck__nav--prev");
    var next = card.querySelector(".zeus-releases-deck__nav--next");
    var total = imgs.length;
    var index = 0;
    var shuffling = false;

    function updateSources() {
      [3, 2, 1, 0].forEach(function (posFromFront, layerIdx) {
        var n = (index + posFromFront) % total;
        if (layers[layerIdx]) {
          layers[layerIdx].src = imgs[n];
          var isFront = layers[layerIdx].closest(".zeus-releases-deck__layer--pos-0");
          var titleEl = card.querySelector(".zeus-releases-deck__card-title");
          layers[layerIdx].alt = isFront && titleEl ? titleEl.textContent.trim() : "";
        }
      });
    }

    function render() {
      updateSources();
    }

    function goTo(target) {
      if (target === index || shuffling) return;

      if (prefersReduced || !stack) {
        index = target;
        render();
        return;
      }

      shuffling = true;
      stack.classList.add("is-shuffling");
      window.setTimeout(function () {
        index = target;
        render();
        stack.classList.remove("is-shuffling");
        shuffling = false;
      }, SHUFFLE_MS);
    }

    function step(dir) {
      goTo((index + dir + total) % total);
    }

    if (prev) {
      prev.addEventListener("click", function (e) {
        e.stopPropagation();
        step(-1);
      });
    }

    if (next) {
      next.addEventListener("click", function (e) {
        e.stopPropagation();
        step(1);
      });
    }

    card.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        step(-1);
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        step(1);
      }
    });

    render();
  }

  function initSection(root) {
    root.querySelectorAll(".zeus-releases-deck__card").forEach(initCard);
  }

  function boot() {
    document.querySelectorAll("[data-zeus-releases-deck]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-zeus-releases-deck]");
    if (root) initSection(root);
  });
})();
